// extracted by mini-css-extract-plugin
export default {"container":"SegmentedInput_container__0dPuO","cell":"SegmentedInput_cell__PdNqY"};